<template>
    <div class="eval">
        <div class="eval_title">
            <span :class="{ 'active': activeType === 1 }" @click="activeTypeChoose(1)">{{ $t('msg_title') }}</span>
            <!-- <span :class="{'active':activeType === 2}" @click="activeTypeChoose(2)">{{ $t('leaveHis') }}</span> -->
            <span class="eval_close" @click="close()"></span>
        </div>
        <div class="eval_body" v-if="activeType === 1">
            <p class="eval_desc">{{ $t('msg_desc') }}</p>
            <span class="label"><span class="required">*</span>{{ $t('userName') }}</span>
            <el-input type="text" v-model="customerName" :placeholder="$t('input')" />
            <span class="label">{{ $t('userPhone') }}</span>
            <el-input type="text" v-model="customerPhone" :placeholder="$t('input')" />
            <span class="label">{{ $t('userEmail') }}</span>
            <el-input type="text" v-model="customerEmail" :placeholder="$t('input')" />
            <span class="label"> <span class="required">*</span>{{ $t('leaveMsgCon') }}</span>
            <el-input type="textarea" v-model="msgContent" />
            <Button style="background:#00A1E2" type="default" size="normal" @click="submitAction">{{ $t('submit') }}
            </Button>
        </div>
        <div v-if="activeType === 2" class="eval_body">
            <div class="leave_msg_item" v-for="item in list">
                <div>
                    <span class="label">客户姓名：</span>
                    <span>{{ item.customerName }}</span>
                </div>
                <div>
                    <span class="label">客户邮箱：</span>
                    <span>{{ item.customerEmail }}</span>
                </div>
                <div>
                    <span class="label">客户电话：</span>
                    <span>{{ item.customerPhone }}</span>
                </div>
                <div>
                    <span class="label">留言内容：</span>
                    <span>{{ item.msgContent }}</span>
                </div>
                <div>
                    <span class="label">提交时间：</span>
                    <span>{{ formDate(item.createTime) }}</span>
                </div>
                <div>
                    <span class="label">留言状态：</span>
                    <span>{{ item.msgState == 1 ? '已处理' : '未处理' }}</span>
                </div>
                <div v-if="item.updateTime">
                    <span class="label">处理时间：</span>
                    <span>{{ item.updateTime }}</span>
                </div>
                <div v-if="item.updateUserName">
                    <span class="label">处理时间：</span>
                    <span>{{ formDate(item.updateUserName) }}</span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { Button } from 'mint-ui';
import chatApi from "../methods";

export default {
    name: "message",
    data() {
        return {
            msgContent: '',
            customerEmail: '',
            customerName: '',
            customerPhone: '',
            activeType: 1,
            list: [],
        }
    },
    mounted() { },
    components: {
        Button
    },
    computed: {
        initData() {
            return this.$store.state.initData
        }
    },
    methods: {
        formDate(value, fmt) {
            if (!value) {
                return '--'
            }
            fmt = fmt || 'yyyy-MM-dd hh:mm:ss';
            if (value && value < 10000000000) {
                value = value * 1000;
            }

            let getDate = new Date(value * 1);
            let o = {
                'M+': getDate.getMonth() + 1,
                'd+': getDate.getDate(),
                'h+': getDate.getHours(),
                'm+': getDate.getMinutes(),
                's+': getDate.getSeconds(),
                'q+': Math.floor((getDate.getMonth() + 3) / 3),
                'S': getDate.getMilliseconds()
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
            }
            for (let k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
                }
            }
            return fmt;
        },

        activeTypeChoose(type) {
            this.activeType = type;
            if (type === 2) {
                this.getLeaveMsg();
            }
        },
        getLeaveMsg() {
            chatApi.getLeaveMsg((result) => {
                this.list = result.data;
            })
        },
        submitAction() {
            // let param = {
            //     "customerEmail": this.customerEmail,
            //     "customerName": this.customerName,
            //     "customerPhone": this.customerPhone,
            //     "msgContent": this.msgContent,
            // }
            if (this.customerName == "") {
                MessageBox({
                    message: "联系姓名不能为空",
                    duration: 1000,
                });
                return;
            }
            if (!this.checkPhone(this.customerPhone)) {
                MessageBox({
                    message: "请输入正确的手机号码",
                    duration: 1000,
                });
                return;
            }

            request
                .leaveMsg({
                    channelType: 1,
                    customerName: this.customerName,
                    customerPhone: this.customerPhone,
                    msgReason: 1,
                    msgContent: this.msgContent,
                    tenantId: this.$store.state.initData.tenantId,
                    userId: this.userInfo.userId,
                })
                .then((res) => {
                    console.log(res);

                    this.$emit("closePopup");

                    MessageBox({
                        message: "留言已发送",
                        duration: 1000,
                    });
                });
        },
        close() {
            this.$emit('closePopup');
        },
         checkPhone(phone) {
            if (!phone) {
                return false;
            }
            return /^1(3|4|5|7|8)\d{9}$/.test(phone);
        },
    }
}
</script>

<style scoped>
.eval {
    background: white;
    height: 500px;
    width: 100%;
}

.eval_title {
    height: 44px;
    background: #f5f6f9;
    color: #2a2a2c;
    font-size: 14px;
    text-align: left;
    position: relative;
}

.eval_title span {
    margin: 5px 15px;
    display: inline-block;
    line-height: 34px;
    text-align: left;
    cursor: pointer;
}

.eval_title .active {
    color: #6c5df9;
}

.eval_close {
    position: absolute;
    right: 5px;
    top: 8px;
    font-size: 20px;
    width: 25px;
    color: #999;
    height: 25px;
    margin: 0 !important;
}

.eval_close::before {
    content: "\2716";
}

.eval_body {
    margin: 0 30px 38px;
    text-align: left;
    height: 450px;
    position: relative;
}

.eval_body button {
    position: absolute;
    bottom: 35px;
    background: #00A1E2;
    color: #ffffff;
    font-size: 14px;
    width: 100%;
    left: 0;
    right: 0;
}

.eval_desc {
    font-size: 14px;
    line-height: 20px;
    margin: 10px;
    text-align: center;
}

.eval_body input {
    display: block;
    outline: none;
    border: .5px solid #e6e6e6;
    background: #ffffff;
    color: #999999;
    font-size: 14px;
    width: 100%;
    height: 40px;
    border-radius: 2px;
    margin-bottom: 16px;
    box-sizing: border-box;
    padding-left: 10px;
}

.required {
    color: red;
    font-size: 15px;
    vertical-align: bottom;
}

.label {
    display: inline-block;
    margin: 5px;
    line-height: 20px;
    font-size: 14px;
    color: #2a2a2c;
}

.leave_msg_item {
    line-height: 14px;
    margin: 10px 5px;
    padding: 5px;
    background: #fafafa;
}

.leave_msg_item div {
    text-align: left;
    font-size: 16px;
    line-height: 18px;
    margin: 8px 0;
}

.leave_msg_item .label {
    width: 90px;
    display: inline-block;
    text-align: right;
    padding-left: 3px;
    color: #666;

}

.leave_msg_item .label+span {
    width: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/h5/message.vue